import axios from "axios";

const baseUrl = "https://ecom-mock.mumzworld.tech";

async function get(endpoint: string) {
  const response = await axios.get(baseUrl + endpoint);
  return response.data;
}

const FETCH_PRODUCTS = "/products?limit=10&page=:page_number"; // Can be Moved to seperate constants file

export const fetchProducts = async (page: number) => {
  return get(FETCH_PRODUCTS.replace(":page_number", page.toString()));
};
